module.exports = __webpack_public_path__ + "static/media/crash.ff583b80.wav";